export default __webpack_public_path__ + "static/media/frequency_slider.46d8ced2.svg";